import React, {Component} from 'react';
import CommesseSelect3TableRow from './CommesseSelect3TableRow'
import PropTypes from 'prop-types';
class CommessaSelect3List extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onCommessaSelect = this.onCommessaSelect.bind(this)
    }

    onCommessaSelect(commessa){
        this.props.onChange(commessa);
    }

    render() {

        let cardClassName = this.props.fluid ? "ui fluid card" : "ui card";
        return (<div className={cardClassName}>

            <div className="content">
                <div className="header">
                    {this.props.title}
                </div>
                <div>
            <table className="ui fixed single line very basic table">
                <tbody>
                {this.props.commesseList.map((commessa) => (
                    <CommesseSelect3TableRow
                        commessa={commessa}
                        key={commessa.idCommessa}
                        onCommessaSelect={this.onCommessaSelect}
                        selected={this.props.commessa && commessa.idCommessa === this.props.commessa.idCommessa}
                    />
                ))}
                </tbody>
            </table>
                </div>
        </div>
        </div>)
    }
}

CommessaSelect3List.PropTypes = {
    title: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fluid: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired,
    commesseList: PropTypes.array.isRequired,
    commessa: PropTypes.object.isRequired,
}

CommessaSelect3List.defaultProps = {
    height: "400px",
    fluid: false,
    compact: false,
    title: 'Seleziona la commessa desiderata...'
};


CommessaSelect3List.contextTypes = {
    router: PropTypes.object
}

export default CommessaSelect3List;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelect3List.js
 **/